import { render, staticRenderFns } from "./QuickAccommodation.vue?vue&type=template&id=1c0c6e95&scoped=true"
import script from "./QuickAccommodation.vue?vue&type=script&lang=js"
export * from "./QuickAccommodation.vue?vue&type=script&lang=js"
import style0 from "./QuickAccommodation.vue?vue&type=style&index=0&id=1c0c6e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c6e95",
  null
  
)

export default component.exports